<template>
  <div v-if="showGameUI"
       style="position: fixed;top:0;left:0;pointer-events: auto;z-index:2000;width:100%;height:100%;background-color: var(--ct-main-bg-color);">
    <iframe style="width:100%;height:100%;"
            v-bind="iframeAttrs"
            frameborder="0"
            scrolling="yes"
            sandbox="allow-top-navigation allow-scripts allow-downloads allow-forms allow-modals allow-orientation-lock allow-pointer-lock allow-popups allow-popups-to-escape-sandbox allow-presentation allow-storage-access-by-user-activation allow-same-origin allow-top-navigation-by-user-activation">
    </iframe>
    <van-floating-bubble
        axis="xy"
        magnetic="x"
        :gap="16"
        v-model:offset="dragOffset"
        style="z-index: 2001;"
        @click="setMenuVisible(true)"
    >
      <template #default>
        <img :src="iconDrag" style="width: 100%; height: 100%;" alt=""/>
      </template>
    </van-floating-bubble>
    <van-overlay :show="showMenu" @click="closeMenu" style="z-index: 2002;">
      <div style="height:100%;display: flex;align-items: center;justify-content: center;flex-direction: column;">
        <div :style="{
        backgroundColor:HNewGameUIConfig.newGameUIType === 3? '#22231A': 'white'
      }" class="ignore-menuListDiv">
          <img @click="eachMenu['callBack']"
               v-for="(eachMenu, index) in menuListInfo"
               :key="index"
               :src="eachMenu.icon"
               style="margin-bottom: 15px; max-width: 180px;"
               alt=""
          />
          <div style="display: flex;flex-direction: row;align-items: center;justify-content: center;">
            <img @click="setMenuVisible(false)" :src="btn_continue" style="height:38px;margin-right: 10px;" alt="">
            <img @click="goBack" :src="btn_back_home" style="height:38px;" alt="">
          </div>
        </div>
        <div :style="hcf.getTextStyle({
        color:'white',marginTop:20,
      })">点击空白处关闭
        </div>
      </div>
    </van-overlay>
  </div>
</template>


<script setup>
  import {emitter, hcf} from "@/components/utils/HComFunctions.js";
  import {useUserStore} from "@/stores/useUser.js";
  import {useHHttp} from "@/hooks/useHHttp.js";
  import {hr} from "@/components/utils/HRouter.js";
  import {useHComApi} from "@/hooks/useHComApi.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
  import Axios from "axios";
  import {hdi} from "@/components/utils/HDeviceInfo.js";

  const user = useUserStore();
  const http = useHHttp();
  const gameUrl = ref("");
  const gameId = ref("");
  const iconDrag = hcf.getNewGameUIIcon("btn_draggable_v2.png");
  const icon_menu_pay = hcf.getNewGameUIIcon("item_pay_v2.png");
  const icon_menu_refresh = hcf.getNewGameUIIcon("item_refresh_v2.png");
  const icon_menu_service = hcf.getNewGameUIIcon("item_service.png");
  const btn_continue = hcf.getNewGameUIIcon("btn_continue_v2.png");
  const btn_back_home = hcf.getNewGameUIIcon("back_home.png");
  let refreshGameTimer = null;
  let pingPongTimer = null;
  let pingPongDio = Axios.create({
    baseURL: '',
    timeout: 8000,
  });
  const showMenu = ref(false);
  const showGameUI = ref(false);
  const dragOffset = ref({x: 16, y: 56});

  const isUrl = (str) => /^https?:\/\//i.test(str);
  const iframeAttrs = computed(() => {
    if (isUrl(gameUrl.value)) {
      return {src: gameUrl.value};
    } else {
      return {srcdoc: gameUrl.value};
    }
  });

  function closeMenu() {
    showMenu.value = false;
  }

  const menuListInfo = [
    {
      "icon": icon_menu_pay,
      "callBack": () => {
        hr.go("pay");
        leaveGame();
      },
    },
    {
      "icon": icon_menu_refresh,
      "callBack": () => {
        gameUrl.value = "";
        if (refreshGameTimer) {
          clearTimeout(refreshGameTimer);
          refreshGameTimer = null;
        }
        refreshGameTimer = setTimeout(() => {
          gameUrl.value = originData.value["game_url"];
        }, 50);
      },
    },
    {
      "icon": icon_menu_service,
      "callBack": () => {
        useHComApi().openService();
        leaveGame();
      },
    },
  ];


  function leaveGame() {
    gameUrl.value = "";
    emitter.emit("REFRESH_HOME_LOBBY_LIST");
    useHComApi().refreshUserBalance();
    showGameUI.value = false;
    http.request(
        "/game/leave",
        () => {
          if(pingPongTimer !== null){
            clearInterval(pingPongTimer);
            pingPongTimer =null;
          }
        }, {
          params: {
            "UserId": user.userId,
            "GameId": gameId.value,
          },
          isShowLoading: false,
        });
  }

  const originData = ref({game_url: "", game_id: 0});

  function goBack() {
    leaveGame();
  }

  function startPingPong(){
    if(pingPongTimer !== null){
      clearInterval(pingPongTimer);
      pingPongTimer =null;
    }
    pingPongTimer = setInterval(()=>{
      pingPongDio.get(`${useHHttp().getServerUrlsConfig().ApiGw}/game/ping-pong?user_id=${user.userId}&game_id=${gameId.value}`);
    },10000);
  }

  onMounted(() => {
    emitter.on("EVENT_INTO_GAME", (data) => {
      originData.value = data;
      if (data) {
        gameUrl.value = data["game_url"] ?? "";
        gameId.value = data["game_id"] ?? 0;
        showGameUI.value = true;
      }
      //启动心跳
      startPingPong();
    })
  });

  onUnmounted(() => {
    emitter.off("EVENT_INTO_GAME");
    if (refreshGameTimer) {
      clearTimeout(refreshGameTimer);
      refreshGameTimer = null;
    }
    if(pingPongTimer !== null){
      clearInterval(pingPongTimer);
      pingPongTimer =null;
    }
  });

  function setMenuVisible(visible) {
    showMenu.value = visible;
  }

</script>


<style scoped>
  .ignore-menuListDiv {
    padding: 23px;
    border-radius: 10px;
    background-color: white;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
</style>
